export default __webpack_public_path__ + "static/media/cards2-grey.57d07b8e.svg";